import React            from "react";
import numeral          from "numeral";

const Substitute = (props) => {

  const {
    exact_qty,
    markup,
    selected_board_qty,
    substitute,
    onReplacePart,
  } = props;

  if(!substitute) return null

  const {
    extra_parts,
    mpn,
    selected_part_supplier,
  } = substitute

  const {selected_pricebreak, description, url: part_supplier_url, supplier} = selected_part_supplier[selected_board_qty]
  const {price} = selected_pricebreak[selected_board_qty]
  const unit_price = (price * (1 + markup))
  const total_price = (exact_qty + (extra_parts[selected_board_qty] || 0)) * price

  const onClick = () => {
    onReplacePart(substitute)
  }

  return (
    <tr >
      <td>
        {mpn}<br/>
        <small>Recommended by {supplier.name}</small>
      </td>
      <td>
        {description}<br/>
        <a href={part_supplier_url} target="_blank">Check Specifications</a>
      </td>
      <td>${numeral(unit_price).format('0.00')}</td>
      <td>
        <button className="btn btn-sm btn-outline-primary" onClick={onClick}>Approve Substitute</button>
      </td>
    </tr>
  )
}

export default Substitute;